import {faFile, faTrashAlt} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {createUseStyles} from 'react-jss'
import {useTranslation} from 'react-i18next'
import {Colors} from '../../../../constants/colors'
import {Fonts} from '../../../../constants/fonts'
import {PayrollFile, UpcomingPayroll} from '../../../../redux/types'
import {formatDateTimeString} from '../../../../util/date'
import PayrollFileRowsModal from "../../PayrollFileRowsModal"
import ConfirmModal from "../../../ConfirmModal"
import {useState} from "react";
import usePayrollActions from "../../../../hooks/usePayrollActions";

interface UploadedPayrollFileProps {
  payrollFile: PayrollFile
  errorsExist: boolean
  onDelete: (payrollFile: PayrollFile) => void
}

const UploadedPayrollFile = ({payrollFile, errorsExist, onDelete}: UploadedPayrollFileProps) => {
  const {t} = useTranslation(['common', 'payrolls'])
  const styles = useStyles()
  const [payrollFileRowsModalVisible, setPayrollFileRowsModalVisible] = useState(false)
  const [confirmDeleteModalVisible, setConfirmDeleteModalVisible] = useState(false)

  const onConfirmDelete = () => {
    onDelete(payrollFile)
    setConfirmDeleteModalVisible(false)
  }

  return (
    <>
      <div className={styles.uploadedFileContainer}>
        <FontAwesomeIcon
          style={{cursor: 'pointer'}}
          icon={faFile}
          size='3x'
          color={errorsExist ? Colors.rubel_700 : Colors.dollar_900}
          title={t('showContent', {ns: 'common'})}
          onClick={() => setPayrollFileRowsModalVisible(true)}
        />
        <div>
          <span style={{fontSize: 11}}>{t('submitted', {ns: 'payrolls'})}</span>
        </div>
        <span style={{fontFamily: Fonts.semiBold, fontSize: 11}}>
          {formatDateTimeString(payrollFile.submitDate)}
        </span>
        <FontAwesomeIcon
          style={{cursor: 'pointer'}}
          icon={faTrashAlt}
          color={Colors.gray1}
          title={t('delete', {ns: 'common'})}
          onClick={() => setConfirmDeleteModalVisible(true)}
        />
      </div>

      <PayrollFileRowsModal
        visible={payrollFileRowsModalVisible}
        rows={payrollFile.payrollFileRows}
        onCloseClick={() => setPayrollFileRowsModalVisible(false)}
      />

      <ConfirmModal
        visible={confirmDeleteModalVisible}
        confirmText={t('confirmDeletePayrollFile', {ns: 'payrolls'})}
        onConfirmClick={onConfirmDelete}
        onCancelClick={() => setConfirmDeleteModalVisible(false)}
      />
    </>
  )
}

interface UploadedFilesContainerProps {
  errorsExist: boolean
  upcomingPayroll: UpcomingPayroll
}

const UploadedFilesContainer = ({
                                  errorsExist,
                                  upcomingPayroll
                                }: UploadedFilesContainerProps) => {
  const styles = useStyles()
  const {deletePayrollFile, deleteOffCyclePayrollFile} = usePayrollActions()

  const handleOnDelete = (payrollFile: PayrollFile) => {
    if (upcomingPayroll.offCycle) {
      deleteOffCyclePayrollFile(payrollFile.externalId, upcomingPayroll.paymentDate)
    } else {
      deletePayrollFile(payrollFile.externalId, upcomingPayroll.paymentDate)
    }
  }

  return (
    <div className={styles.uploadedFilesContainer}>
      {upcomingPayroll.payrollFiles.map((file, index) => {
        return (
          <UploadedPayrollFile payrollFile={file}
                               errorsExist={errorsExist}
                               onDelete={handleOnDelete}
                               key={`container_${index}`}/>
        )
      })}
    </div>
  )
}

const useStyles = createUseStyles({
  uploadedFilesContainer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 40,
    marginBottom: 20
  },
  uploadedFileContainer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  }
})

export default UploadedFilesContainer
